import { Chip, Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { Fragment } from 'react';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Tooltip } from 'core/elements';
import { Direction, Variant } from 'theme/enums';

import { getAnomalyBadges } from '../utils';

export const AnomaliesCell = ({ data }: ICellRendererParams) => {
  // Group rows have no data — render blank, not the confirmed-empty placeholder.
  if (!data) {
    return null;
  }

  const badges = getAnomalyBadges(data);

  if (!badges.length) {
    return <>{DEFAULT_PLACEHOLDER}</>;
  }

  return (
    <Stack
      direction={Direction.ROW}
      sx={{ alignItems: 'center', flexWrap: 'wrap', gap: 0.5, height: '100%', padding: '4px 0' }}
    >
      {badges.map((badge, index) => {
        // Content-derived key stays stable across reorders; the index keeps it
        // unique if the BE ever sends the same flag twice (matches ChipListCell).
        const key = `${badge.key}-${index}`;

        const chip = (
          <Chip variant={Variant.SOFT} color={badge.color}>
            {badge.label}
          </Chip>
        );

        if (!badge.tooltip) {
          return <Fragment key={key}>{chip}</Fragment>;
        }

        return (
          <Tooltip key={key} title={badge.tooltip}>
            {chip}
          </Tooltip>
        );
      })}
    </Stack>
  );
};
